import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-subsection" }
const _hoisted_2 = { class: "details-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "details-title" }, "Besoin de plus de détails ?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "details-description" }, " Explorez toutes les fonctionnalités de Florisuite en profondeur pour comprendre comment chaque outil peut propulser votre entreprise. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "details-button-text" }, "Voir toutes les fonctionnalités", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        class: "details-button",
        to: "/fonctionnalites"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}